module.exports = __webpack_public_path__ + "img/goods11_2.8e75bf94.jpg";